define('glu/combobox',['require','./$','select2'],function(require) {
    'use strict';

    var $ = require('./$');

    // Pull in Select2
    require('select2');

    var originalSelect2 = $.fn.select2;

    // create a new method to extend the default behavior of this component
    $.fn.comboBox = function() {
        // TODO: override behavior for autocomplete.

        var args = arguments,
            options = args[0] || {};

        if (options.searchField === false) {
            options.minimumResultsForSearch = -1;
        }

        // If the user has not selected a valid option, clear the selected value
        return originalSelect2.apply(this, args);
    };
});

